var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#34e0a1}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9 12h3V9.5H9.3c-.1.8-.3 1.7-.3 2.5zm5.9-4.6c-.6-1-1.2-1.7-1.9-1.9v2.9h2.4c-.2-.3-.3-.6-.5-1zm-4.8 0c-.2.4-.3.7-.5 1.1H12V5.6c-.7.2-1.3.8-1.9 1.8zm0 10.2c.6 1 1.2 1.7 1.9 1.9v-2.9H9.6c.2.3.3.6.5 1zM9.2 7c.2-.4.4-.7.6-1-1.2.5-2.3 1.4-3 2.5h1.8L9.2 7zm-.6 9.5H6.8c.8 1.1 1.8 2 3.1 2.5l-.6-.9c-.3-.6-.5-1.1-.7-1.6zm-.3-7H6.2c-.4.8-.6 1.6-.7 2.5H8c0-.9.1-1.7.3-2.5zM8 13H5.5c.1.9.3 1.7.7 2.5h2.1c-.2-.8-.3-1.7-.3-2.5zm1.3 2.5H12V13H9c0 .8.2 1.7.3 2.5zM17 12h2.5c-.1-.9-.3-1.7-.7-2.5h-2.1c.2.8.3 1.6.3 2.5zm-1.8-6l.6.9c.2.5.5 1 .6 1.5h1.8c-.7-1-1.8-1.9-3-2.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20 0H4C1.8 0 0 1.8 0 4v16c0 2.2 1.8 4 4 4h16c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4zm-1.8 18.2c-1.5 1.5-3.5 2.3-5.7 2.3s-4.2-.8-5.7-2.3c-1.5-1.5-2.3-3.5-2.3-5.7s.8-4.2 2.3-5.7 3.5-2.3 5.7-2.3 4.2.8 5.7 2.3c1.5 1.5 2.3 3.5 2.3 5.7s-.8 4.2-2.3 5.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.7 15.5h2.1c.4-.8.6-1.6.7-2.5H17c0 .8-.1 1.7-.3 2.5zM16 13h-3v2.5h2.7c.1-.8.3-1.6.3-2.5zm-.2 5l-.6.9c1.2-.5 2.3-1.4 3.1-2.5h-1.8c-.3.6-.5 1.1-.7 1.6zm-.1-8.5H13V12h3c0-.8-.2-1.7-.3-2.5zm-2.7 7v2.9c.7-.2 1.3-.8 1.9-1.9.2-.3.3-.7.5-1.1H13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/Website.ea6164c7133719f2b4f7cb04a63c2313.svg";
export { ForwardRef as ReactComponent };